import buildLocalizeFn from '../../../_lib/buildLocalizeFn/index';

function ordinalNumber(dirtyNumber, dirtyOptions) {
  const number = Number(dirtyNumber);
  return number + '.';
}

const eraValues = {
  narrow: ['p.n.e.', 'n.e.'],
  abbreviated: ['p.n.e.', 'n.e.'],
  wide: ['prije nove ere', 'nove ere'],
};

const quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: [
    '1. tromjesečje',
    '2. tromjesečje',
    '3. tromjesečje',
    '4. tromjesečje',
  ],
  wide: [
    '1. tromjesečje',
    '2. tromjesečje',
    '3. tromjesečje',
    '4. tromjesečje',
  ],
};

const monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: [
    'jan',
    'feb',
    'mar',
    'apr',
    'maj',
    'jun',
    'jul',
    'aug',
    'sep',
    'okt',
    'nov',
    'dec',
  ],
  wide: [
    'januar',
    'februar',
    'mart',
    'april',
    'maj',
    'juni',
    'juli',
    'avgust',
    'septembar',
    'oktobar',
    'novembar',
    'decembar',
  ],
};

const dayValues = {
  narrow: ['N', 'P', 'U', 'S', 'Č', 'P', 'S'],
  short: ['ne', 'po', 'ut', 'sr', 'če', 'pe', 'su'],
  abbreviated: ['ned', 'pon', 'uto', 'sri', 'čet', 'pet', 'sub'],
  wide: [
    'nedjelja',
    'ponedeljak',
    'utorak',
    'srijeda',
    'četvrtak',
    'petak',
    'subota',
  ],
};

const dayPeriodValues = {
  narrow: {
    am: 'prijepodne',
    pm: 'poslijepodne',
    midnight: 'ponoć',
    noon: 'podne',
    morning: 'jutro',
    afternoon: 'poslijepodne',
    evening: 'večer',
    night: 'noć',
  },
  abbreviated: {
    am: 'prijepodne',
    pm: 'poslijepodne',
    midnight: 'ponoć',
    noon: 'podne',
    morning: 'jutro',
    afternoon: 'poslijepodne',
    evening: 'večer',
    night: 'noć',
  },
  wide: {
    am: 'prijepodne',
    pm: 'poslijepodne',
    midnight: 'ponoć',
    noon: 'podne',
    morning: 'jutro',
    afternoon: 'poslijepodne',
    evening: 'večer',
    night: 'noć',
  },
};

const localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide',
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    },
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide',
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
  }),
};

export default localize;
